<template>
  <!-- name: '我要捐-项目详情' -->
  <div class="projectDetailWrap">
    <van-loading v-if="isShowLoading">加载中...</van-loading>
    <div v-else>
      <div class="baseInfoBox" v-show="isBaseInfoShow">
        <SwiperBanner :bannerList="projectObj.imgList" />
        <h3>{{ projectObj.theme }}</h3>
        <span class="labelClass" v-show="projectObj.type === 1">
          <img
            src="https://img.bbalt.cn/imgh5/donate/icon_place.svg"
            alt=""
          />{{ projectObj.sizeName }}</span
        >
      </div>
      <div class="tabBoxWrap">
        <div :class="isFixed ? 'tabBox is-fixed' : 'tabBox'" ref="tabBoxRef">
          <div
            :class="
              curTab === '项目需求' ? 'tabItemClass actclass' : 'tabItemClass'
            "
            @click="
              curTab = '项目需求';
              handleScroll('.needBox');
            "
          >
            项目需求
            <span class="lineClass" v-show="curTab === '项目需求'"></span>
          </div>
          <div
            :class="
              curTab === '项目反馈' ? 'tabItemClass actclass' : 'tabItemClass'
            "
            @click="
              curTab = '项目反馈';
              handleScroll('.feedbackBox');
            "
          >
            项目反馈
            <span class="lineClass" v-show="curTab === '项目反馈'"></span>
          </div>
        </div>
      </div>
      <!-- 项目需求 -->
      <div class="needBox" style="scroll-margin-top: 106px">
        <h4 class="titleClass">项目介绍</h4>
        <p class="profileClass" v-html="projectObj.description"></p>
        <div class="stateBox">
          <div class="daysClass">
            <img
              src="https://img.bbalt.cn/imgh5/donate/icon_home.svg"
              alt=""
            />募集天数 {{ projectObj.duration }} 天
          </div>
          <div class="progressBox">
            <div
              class="progressClass"
              :style="`width:${
                projectObj.donateCount + projectObj.demandCount === 0
                  ? 50
                  : (projectObj.donateCount / projectObj.demandCount) * 100
              }%`"
            ></div>
            <span class="textClass"
              >{{ projectObj.donateCount ? projectObj.donateCount : 0 }}件/{{
                projectObj.demandCount ? projectObj.demandCount : 0
              }}件</span
            >
          </div>
        </div>
        <div class="btnBox">
          <button
            @click="$toast.fail('暂时不开放此功能')"
          >
            <img
              src="https://img.bbalt.cn/imgh5/donate/icon_donate_post.svg"
              alt=""
            />生成募集海报
          </button>
          <button>
            <a
              href="https://www.lianquan.org/ContractPlus_ContractInfo?guid=9E0EBD7C6C7912DDD335DBAD6EA3878D66114AE1DE9EA1E2EA228ACC991307C2A8DCE57FAD5C174241EE29A6D90FD7BD"
              target="_blank"
            >
              <img
                src="https://img.bbalt.cn/imgh5/donate/icon_donate_money.svg"
                alt=""
              />我要捐款</a
            >
          </button>
        </div>
        <div class="linkBox">
          <p>联系人：{{ projectObj.contract }}</p>
          <p>联系电话：{{ projectObj.mobile }}</p>
          <p>收件地址：{{ projectObj.addressDetail }}</p>
        </div>
        <h4 class="titleClass">参与捐赠人</h4>
        <div class="donatorBox">
          <img
            v-for="(item, index) in projectObj.donatorList"
            :key="index"
            :src="item"
            alt=""
          />
        </div>
        <h4 class="titleClass">
          {{ projectObj.type === 1 ? "衣物" : "物品" }}需求
        </h4>
        <table>
          <tr
            v-for="(item, index) in projectObj.needList"
            :key="index"
            :class="item.donateCount === 0 ? 'isGray' : ''"
          >
            <td v-show="projectObj.type === 1">
              {{ item.sizeHeightName }}
            </td>
            <td v-show="projectObj.type === 1" style="width: 8%; flex: none">
              {{ item.sexName }}
            </td>
            <td v-show="projectObj.type === 1" style="width: 18%; flex: none">
              {{ item.seasonName }}
            </td>
            <td v-show="projectObj.type === 1" style="width: 20%; flex: none">
              缺口 {{ item.insufficiency }}
            </td>
            <td v-show="projectObj.type === 1 && item.remark">
              {{ item.remark }}
            </td>
            <td v-show="projectObj.type === 2" style="width: 18%; flex: none">
              {{ item.nameCn }}
            </td>
            <td v-show="projectObj.type === 2">{{ item.goodsName }}</td>

            <td v-show="projectObj.type === 2" style="width: 20%; flex: none">
              缺口 {{ item.insufficiency }}
            </td>
            <td v-show="projectObj.type === 2 && item.remark">
              {{ item.remark }}
            </td>

            <td class="countBox">
              <img
                :src="`https://img.bbalt.cn/imgh5/donate/icon_minus${
                  item.donateCount === 0 ? '' : '_act'
                }.svg`"
                alt=""
                @click="
                  () => {
                    item.donateCount--;
                    handleSum();
                    handleCount(index, item.donateCount, item.insufficiency);
                  }
                "
                :class="item.donateCount === 0 ? 'img-onlyRead' : ''"
              />
              <input
                type="tel"
                class="numberboxClass"
                v-model="item.donateCount"
                @mousedown="
                  curCount = item.donateCount;
                  handleSum();
                "
                :disabled="item.insufficiency === 0"
                @change="
                  handleCount(index, item.donateCount, item.insufficiency);
                  handleSum();
                "
              />
              <img
                :src="`https://img.bbalt.cn/imgh5/donate/icon_add${
                  item.insufficiency === 0 ? '' : '_act'
                }.svg`"
                alt=""
                @click="
                  item.donateCount++;
                  handleSum();
                  handleCount(index, item.donateCount, item.insufficiency);
                "
                :disabled="item.insufficiency === 0"
                :class="item.insufficiency === 0 ? 'img-onlyRead' : ''"
              />
            </td>
          </tr>
        </table>
        <div class="btnBox">
          <button @click="handleInto">
            <img
              src="https://img.bbalt.cn/imgh5/donate/icon_donate_cart.svg"
              alt=""
            />
            放入捐赠篮
          </button>
          <button class="btnDonateClass" @click="showPointSum = true">
            立即捐赠
          </button>
        </div>
      </div>
      <!-- 项目反馈 -->
      <div class="feedbackBox" style="scroll-margin-top: 106px">
        <h4 class="titleClass">项目反馈</h4>
        <div class="labelBox">
          <span
            v-for="(item, index) in projectObj.feedBackTimes"
            :key="index"
            :class="item === curFeedBackTime ? 'actClass' : ''"
            @click="handleFeedBack(item)"
            >{{ item }}</span
          >
        </div>
        <div class="feedBackList">
          <ul>
            <li v-for="(item, index) in curFeeBackList" :key="index">
              <SwiperBanner :bannerList="item.imgList" />
              <p v-html="item.feedback"></p>
            </li>
          </ul>
        </div>
        <div class="noDataBox" v-show="curFeeBackList.length === 0">
          <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />
          暂无数据
        </div>
      </div>
    </div>

    <!-- 捐赠篮 -->
    <div class="fixBasket" @click="handleOpenFixBasket">
      <span class="basketTotalClass">{{ basketTotal }}</span>
    </div>
    <!-- 蒙版 -->
    <div class="maskBox" @click="handleCloseFixBasket">
      <Basket v-if="isMask" :donateType="projectObj.type" />
    </div>
    <van-dialog
      v-model="showPoint"
      title="捐赠提示"
      confirmButtonColor="#00a392"
      :showCancelButton="true"
      confirmButtonText="没有其他捐赠了"
      cancelButtonText="再考虑一下"
      @confirm="handleDonate()"
    >
      <p>
        若您计划一次捐赠多{{
          projectObj.type === 1
            ? "件衣物"
            : donateList.length > 0 && donateList[0].nameCn === "图书"
            ? "本图书"
            : "件物品"
        }}，鼓励您依次加入捐赠篮，再从捐赠篮中一次性提交，以便减少捐赠订单数量，简化后续操作。
      </p>
    </van-dialog>
    <van-dialog
      v-model="showPointSum"
      title="捐赠提示"
      confirmButtonColor="#00a392"
      :showCancelButton="sum > 0 ? true : false"
      :confirmButtonText="sum > 0 ? '我确认捐赠' : '确定'"
      cancelButtonText="再考虑一下"
      @confirm="handleConfirm()"
    >
      <div v-if="sum > 0">
        <p v-show="projectObj.type === 1">
          我已确认所捐爱心衣物为8成新、无破损，并且已清洗消毒。
        </p>
        <p v-show="projectObj.type === 2">
          {{
            donateList.length > 0 && (donateList[0].nameCn === "图书" || donateList[0].categoryName === '图书')
              ? "我已确认所捐爱心图书为8成新正版图书，无污渍无破损。"
              : "我已确认所捐爱心物品为8成新、无破损，并且已清洗消毒"
          }}
        </p>
        <ul v-if="projectObj.type === 1">
          <li v-for="(item, index) in donateList" :key="index">
            {{ item.sizeHeightName }} {{ item.sexName }} {{ item.seasonName }}
            {{ item.donateCount }}
          </li>
        </ul>
        <ul v-else>
          <li v-for="(item, index) in donateList" :key="index">
            {{ item.nameCn }} {{ item.goodsName }} {{ item.donateCount }}
          </li>
        </ul>
        <p>总计：{{ sum }}</p>
      </div>

      <p v-else>
        你捐赠的{{ projectObj.type === 1 ? "衣物" : "物品" }}数量为0，请添加{{
          projectObj.type === 1 ? "衣物" : "物品"
        }}
      </p>
    </van-dialog>

    <van-dialog
      v-model="showPointBasket"
      title="捐赠提示"
      confirmButtonColor="#00a392"
      confirmButtonText="确认"
    >
      <p>请选择捐赠衣物</p>
    </van-dialog>
  </div>
</template>

<script>
import SwiperBanner from "@/components/SwiperBanner.vue";
import Basket from "./basket.vue";
import { demandDetail, fastDonate } from "@/api/donate";
import { getShareInfo } from "@/utils/share.js";
import mixin from "@/utils/mixin.js";
export default {
  mixins: [mixin],
  components: { SwiperBanner, Basket },
  data() {
    return {
      projectObj: {
        imgList: [],
        donatorList: [],
        needList: [],
        feedBackTimes: [],
        feedBackList: [],
        type: 1, //1 捐衣 2 捐物
      },
      curTab: "项目需求",
      curCount: "",
      curFeedBackTime: "",
      curFeeBackList: [],
      showPoint: false,
      showPointSum: false,
      sum: 0,
      donateList: [],
      showPointBasket: false,
      basketTotal: 0,
      isMask: false,
      isBaseInfoShow: true,
      isFixed: false,
      isShowLoading: true,
    };
  },
  created() {
    this.getDemandDetail();
    this.setbasketTotal();
    this.curTab = this.$route.query.type ? this.$route.query.type : this.curTab;
    if (this.$route.query.type) {
      this.isFixed = true;
    }
  },

  methods: {
    async getDemandDetail() {
      const { content } = await demandDetail({ id: this.$route.query.id });
      this.projectObj.theme = content.theme;
      this.projectObj.imgList = content.picUrls.split(",").map((item) => {
        return { url: item };
      });
      getShareInfo(this.projectObj.theme, this.projectObj.imgList[0].url);
      this.projectObj.type = content.type;
      this.projectObj.id = content.id;
      this.projectObj.description = content.description;
      this.projectObj.duration = content.duration;
      this.projectObj.demandCount = content.demandCount;
      this.projectObj.donateCount = content.donateCount
        ? content.donateCount
        : 0; //需求数量
      this.projectObj.contract = content.contract
      this.projectObj.mobile = content.mobile
      this.projectObj.addressDetail = content.addressDetail
      this.projectObj.donatorList = content.wxUserInfos
        ? content.wxUserInfos.split(",")
        : [];

      if (this.projectObj.type === 1) {
        this.projectObj.needList = content.clothesDetailInserts
          ? content.clothesDetailInserts.map((item) => {
              item.donateCount = 0;
              return item;
            })
          : [];
      }
      if (this.projectObj.type === 2) {
        this.projectObj.needList = content.demandGoodsDetails
          ? content.demandGoodsDetails.map((item) => {
              item.donateCount = 0;
              return item;
            })
          : [];
      }

      if (this.projectObj.type === 1) {
        const donateClothes = JSON.parse(localStorage.getItem("donateClothes"));
        if (donateClothes) {
          donateClothes.map((item) => {
            if (this.$route.query.id === item.id) {
              this.projectObj.needList.map((subItem1) => {
                item.details.map((subItem2) => {
                  if (subItem1.id === subItem2.id) {
                    subItem1.donateCount = subItem2.donateCount;
                  }
                });
              });
              this.donateList = item.details;
            }
          });
        }
        localStorage.setItem("curSelectTab", "捐衣");
      } else {
        const donateGoods = JSON.parse(localStorage.getItem("donateGoods"));
        if (donateGoods) {
          donateGoods.map((item) => {
            if (this.$route.query.id === item.id) {
              this.projectObj.needList.map((subItem1) => {
                item.details.map((subItem2) => {
                  if (subItem1.id === subItem2.id) {
                    subItem1.donateCount = subItem2.donateCount;
                  }
                });
              });
              this.donateList = item.details;
            }
          });
        }
        localStorage.setItem("curSelectTab", "捐物");
      }

      this.projectObj.sizeName = content.sizeName;
      this.projectObj.feedBackList = content.demandFeedbacks;
      this.projectObj.feedBackTimes = content.demandFeedbacks
        ? content.demandFeedbacks.map((item) => {
            return item.createTime.slice(0, 11);
          })
        : [];

      this.curFeedBackTime = this.projectObj.feedBackTimes[0];
      this.handleFeedBack();
      this.isShowLoading = false;

      if (this.curTab === "项目反馈") {
        setTimeout(function () {
          document.querySelector(".feedbackBox").scrollIntoView();
        }, 10);
      }
    },
    handleOpenFixBasket() {
      document.getElementsByClassName("maskBox")[0].style.display = "block";
      document.getElementsByClassName("projectDetailWrap")[0].style.overflow =
        "hidden";
      this.isMask = true;
    },
    handleCloseFixBasket(event) {
      if (event.target.className === "maskBox") {
        document.getElementsByClassName("maskBox")[0].style.display = "none";
        document.getElementsByClassName("projectDetailWrap")[0].style.overflow =
          "auto";
        this.isMask = false;
        this.setbasketTotal();
      }
    },
    // 加入捐赠篮
    handleInto(event) {
      if (this.sum === 0) {
        this.showPointBasket = true;
      } else {
        let x = event.x;
        let y = event.y;
        const cloth = document.createElement("div");
        cloth.style.position = "fixed";
        cloth.style.left = "0px";
        cloth.style.zIndex = 5;
        cloth.style.top = "0px";
        cloth.style.width = "5.3vw";
        cloth.style.height = "5.3vw";
        cloth.style.backgroundImage = `url("https://img.bbalt.cn/imgh5/donate/icon_donate_cart.svg")`;
        cloth.style.backgroundSize = " 100%";
        cloth.style.transform = "translate(" + x + "px," + y + "px)";
        cloth.style.transition = "transform .5s linear";
        document.body.appendChild(cloth);
        setTimeout(function () {
          let target = document.querySelector(".fixBasket");
          let targetX = target.offsetLeft + target.offsetWidth / 2;
          let targetY = target.offsetTop;
          cloth.style.transform =
            "translate(" + targetX + "px," + targetY + "px)";
        }, 0);
        cloth.ontransitionend = function () {
          this.remove();
        };
        this.addLocalStorage();
      }
    },
    handleFeedBack(val) {
      this.curFeedBackTime = val ? val : this.curFeedBackTime;
      this.curFeeBackList = this.projectObj.feedBackList.filter((item) => {
        item.imgList = item.feedbackImgUrl.split(",").map((item) => {
          return { url: item };
        });
        if (this.curFeedBackTime === item.createTime.slice(0, 11)) {
          return item;
        }
      });
    },
    handleScroll(dom) {
      document.querySelector(dom).scrollIntoView();
    },
    handleSum() {
      this.sum = 0;
      this.donateList = [];
      this.projectObj.needList.forEach((item) => {
        const count = Number(item.donateCount) || 0;
        item.donateCount = count;
        this.sum += count;
        if (count > 0) {
          this.donateList.push(item);
        }
      });
    },
    async handleDonate() {
      let tempList = [
        {
          id: this.projectObj.id,
          type: this.projectObj.type,
          demandCount: this.sum,
          details: this.donateList.map((item) => {
            return {
              id: item.id,
              number: item.donateCount,
            };
          }),
        },
      ];
      let donateObj;
      if (this.projectObj.type === 1) {
        donateObj = [
          {
            theme: this.projectObj.theme,
            list: this.donateList.map((item) => {
              return {
                sexName: item.sexName,
                seasonName: item.seasonName,
                donateCount: item.donateCount,
                sizeHeightName: item.sizeHeightName,
              };
            }),
          },
        ];
      } else {
        donateObj = [
          {
            theme: this.projectObj.theme,
            list: this.donateList.map((item) => {
              return {
                nameCn: item.nameCn,
                goodsName: item.goodsName,
                donateCount: item.donateCount,
              };
            }),
          },
        ];
      }
      const { code, content, message } = await fastDonate(tempList);
      if (code === 200) {
        this.$toast.success("操作成功");
        this.$router.push({
          path: "/send",
          query: {
            code: content.code,
            dataList: JSON.stringify(donateObj),
            donateInfoId: content.donateInfoId,
            donateType: this.projectObj.type,
            id: this.projectObj.id,
          },
        });
      } else {
        this.$toast.fail(message);
      }
    },
    addLocalStorage() {
      if (this.projectObj.type === 1) {
        let curList = [];
        if (localStorage.getItem("donateClothes")) {
          curList = JSON.parse(localStorage.getItem("donateClothes"));
          if (curList.some((item) => item.id === this.projectObj.id)) {
            curList.map((item, index) => {
              if (item.id === this.projectObj.id) {
                item.details = this.donateList;
                curList[index] = item;
              }
            });
          } else {
            curList.push({
              id: this.projectObj.id,
              theme: this.projectObj.theme,
              details: this.donateList,
            });
          }
        } else {
          curList = [
            {
              id: this.projectObj.id,
              theme: this.projectObj.theme,
              details: this.donateList,
            },
          ];
        }
        let curStorage = JSON.stringify(curList);

        localStorage.setItem("donateClothes", curStorage);
      } else {
        let curList = [];
        if (localStorage.getItem("donateGoods")) {
          curList = JSON.parse(localStorage.getItem("donateGoods"));
          if (curList.some((item) => item.id === this.projectObj.id)) {
            curList.map((item, index) => {
              if (item.id === this.projectObj.id) {
                item.details = this.donateList;
                curList[index] = item;
              }
            });
          } else {
            curList.push({
              id: this.projectObj.id,
              theme: this.projectObj.theme,
              details: this.donateList,
            });
          }
        } else {
          curList = [
            {
              id: this.projectObj.id,
              theme: this.projectObj.theme,
              details: this.donateList,
            },
          ];
        }
        let curStorage = JSON.stringify(curList);
        localStorage.setItem("donateGoods", curStorage);
      }
      this.setbasketTotal();
    },
    setbasketTotal() {
      let clothesList = localStorage.getItem("donateClothes")
        ? JSON.parse(localStorage.getItem("donateClothes"))
        : [];
      let goodsList = localStorage.getItem("donateGoods")
        ? JSON.parse(localStorage.getItem("donateGoods"))
        : [];
      let clothesNum = 0;
      clothesList.map((item) => {
        item.details.map((subItem) => {
          clothesNum += Number(subItem.donateCount);
        });
      });
      let goodsNum = 0;
      goodsList.map((item) => {
        item.details.map((subItem) => {
          goodsNum += Number(subItem.donateCount);
        });
      });
      this.basketTotal = Number(clothesNum) + Number(goodsNum);
      localStorage.setItem("basketTotal", this.basketTotal);
    },
    handleCount(index, val, max) {
      const count = Number(val);
      if (count < 0 || !count) {
        this.projectObj.needList[index].donateCount = 0;
        return;
      }
      if (count > Number(max)) {
        this.projectObj.needList[index].donateCount = Number(max);
        return;
      }
      this.projectObj.needList[index].donateCount = count;
    },
    handlePageScroll() {
      let scrollTop =
        window.offsetTop ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed =
        scrollTop >
        document.querySelector(".tabBoxWrap").getBoundingClientRect().top
          ? true
          : false;
      if (
        document.querySelector(".feedbackBox").getBoundingClientRect().top <=
        180
      ) {
        this.curTab = "项目反馈";
      } else {
        this.curTab = "项目需求";
        this.isBaseInfoShow = true;
      }
    },
    handleConfirm() {
      if (this.sum > 0) {
        this.showPoint = true;
      }
    },
  },
  mounted() {
    document
      .querySelector(".projectDetailWrap")
      .addEventListener("scroll", this.handlePageScroll);
    this.sum = Number(localStorage.getItem("basketTotal"));
  },
  destroyed() {
    getShareInfo();
  },
};
</script>

<style lang="scss" scoped>
.projectDetailWrap {
  height: calc(100% - 137px);
  width: 100%;
  overflow: auto;
  padding-bottom: 37px;
  border-top: 1px solid #ededed;
  display: inline-block;
  font-family: PingFangSC, PingFang SC;
  background-color: #f5f5f5;
  display: flex;
  flex-flow: column;
  padding-top: 96px;

  .baseInfoBox {
    padding: 31px 32px 24px 32px;
    background-color: #fff;

    .swiperBox {
      height: 316px;
    }

    h3 {
      margin-top: 40px;
      width: 100%;
      font-size: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 46px;
    }

    .labelClass {
      height: 40px;
      background: #679fd2;
      border-radius: 4px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      padding-right: 12px;
      display: inline-block;
      margin-top: 24px;

      img {
        width: 20px;
        height: 20px;
        margin: 0px 8px;
      }
    }
  }

  .tabBox {
    width: 100%;
    height: 88px;
    border-bottom: 1px solid #ededed;
    display: flex;
    justify-content: space-between;
    line-height: 88px;
    background-color: #fff;

    .tabItemClass {
      position: relative;
      height: 100%;
      width: 50%;
      text-align: center;
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #999999;

      &.actclass {
        font-weight: 600;
        color: #333333;
      }

      span {
        position: absolute;
        width: 63px;
        height: 6px;
        background: #fe66a6;
        bottom: -3px;
        left: calc(50% - 32px);
      }
    }

    &.is-fixed {
      position: fixed;
      top: 96px;
      z-index: 10;
    }
  }

  .countBox {
    width: 164px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
    }

    .numberboxClass {
      width: 56px;
      height: 36px;
      background: #f5f5f5;
      border-radius: 2px;
      border: none;
      text-align: center;
      color: #999999;
    }
  }

  .titleClass {
    height: 46px;
    font-size: 36px;
    font-weight: 600;
    color: #333333;
    line-height: 46px;
    margin-top: 80px;
  }

  .btnBox {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    button,
    a {
      width: 335px;
      height: 96px;
      background: #ffffff;
      border-radius: 48px;
      border: 2px solid #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      font-weight: 400;
      color: #333333;

      img {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }

      &.btnDonateClass {
        background: #fe66a6;
        font-size: 32px;
        font-weight: 600;
        color: #ffffff;
      }

      .ball {
        transition: "left .6s linear, top .6s cubic-bezier(0.5, -0.5, 1, 1)";
        position: absolute;
        // display: none;
      }
    }
  }

  .needBox {
    padding: 0px 32px;
    background-color: #fff;
    display: inline-block;
    padding-bottom: 66px;

    .baseInfoBox {
      padding: 0px;
      margin-top: 20px;
    }

    .profileClass {
      margin-top: 32px;
      font-size: 26px;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
    }

    .stateBox {
      width: 100%;
      height: 160px;
      margin-top: 40px;
      background-image: url("https://img.bbalt.cn/imgh5/donate/bg_state.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      justify-content: center;

      .daysClass {
        margin: 0px 32px;
        height: 36px;
        font-size: 28px;
        font-weight: 600;
        color: #563144;
        line-height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 28px;

        img {
          width: 30px;
          height: 30px;
          margin-right: 21px;
        }
      }

      .progressBox {
        width: calc(100% - 64px);
        height: 48px;
        background: #ffffff;
        border-radius: 24px;
        margin: 16px 32px 32px 32px;
        position: relative;
        font-size: 24px;
        font-weight: 400;
        color: #fe66a6;
        line-height: 48px;

        .progressClass {
          height: 100%;
          background: #fe66a6;
          border-radius: 24px;
          color: #ffffff;
          position: absolute;
          padding-left: 24px;
        }
        .textClass {
          position: absolute;
          color: #563144;
          width: 100%;
          text-align: center;
          font-size: 28px;
          font-weight: 600;
        }
      }
    }

    .linkBox {
      margin-top: 56px;
      font-size: 26px;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
    }

    .donatorBox {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      img {
        margin-top: 32px;
        width: 72px;
        height: 72px;
      }
    }

    table {
      display: block;
      width: 100%;

      tr {
        width: 100%;
        height: 104px;
        border-bottom: 1px solid #ededed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px auto;
        color: #333333;

        .numberboxClass {
          color: #333333;
        }

        &.isGray {
          color: #999999;

          .numberboxClass {
            color: #999999;
          }
        }
        :last-child {
          flex: none;
        }

        td {
          flex: 1;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        td:hover {
          overflow: visible; /* 显示全部内容 */
          white-space: normal; /* 允许正常换行 */
          z-index: 10; /* 防止被遮挡 */
          background: white; /* 背景防止文字重叠 */
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  .feedbackBox {
    display: inline-block;
    padding: 0px 32px;
    background-color: #f5f5f5;
    width: 100%;

    .labelBox {
      margin-top: 31px;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      display: flex;
      flex-flow: row;

      span {
        min-width: 180px;
        height: 57px;
        background: #eeeeee;
        border-radius: 28px;
        border: 1px solid #dddddd;
        display: inline-block;
        font-size: 28px;
        font-weight: 400;
        color: #999999;
        line-height: 57px;
        text-align: center;
        margin-right: 32px;
        flex: 1;

        &.actClass {
          background: #fe66a6;
          color: #fff;
        }
      }
    }

    .feedBackList {
      margin-top: 24px;

      ul {
        li {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #dddddd;

          p {
            font-size: 26px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
            margin: 44px 34px 42px 34px;
          }
        }
      }
    }
  }

  .fixBasket {
    width: 120px;
    height: 124px;
    background-image: url("https://img.bbalt.cn/imgh5/donate/btn_cart.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: fixed;
    bottom: 124px;
    right: 0px;
    z-index: 1;

    .basketTotalClass {
      display: flex;
      width: 40px;
      height: 40px;
      background: red;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-radius: 50%;
      margin-left: 70px;
    }
  }

  .maskBox {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(51, 51, 51, 0.6);
    top: 0px;
    left: 0px;
    z-index: 12;
    padding-top: 81px;
    display: none;
  }
}

.img-onlyRead {
  pointer-events: none;
}

.noDataBox {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  img {
    width: 80%;
    margin: 30px auto;
  }
}

.van-dialog p,
.van-dialog ul {
  padding: 20px 40px;
  line-height: 40px;
}

::v-deep .van-dialog__header {
  color: #000;
}
.van-loading {
  text-align: center;
}
</style>
